import { Box, Divider, IconButton } from "@mui/material";
import React, { useState, useEffect } from "react";
import ValueContainer from "../../DetailContainer/ValueContainer";
import DropdownContainer, {
  Datatype,
} from "../../DetailContainer/DropdownContainer";
import { format } from "date-fns";
import { useMessage } from "../../../../base/MessageProvider";
import { hideLoadingOverlay, showLoadingOverlay } from "../../../../utils";
import { useDispatch, useSelector } from "react-redux";
import {
  deleteArtistProfiles,
  getArtistById,
  markArtistShowcase,
  markArtistVerified,
} from "../../../actions/artist";
import clsx from "clsx";
import { CameraAlt, Info, MoreHoriz, Verified } from "@mui/icons-material";
import OAuth from "../../OAuth";
import ImageUploadOptions from "../../../../components/ImageUploadOptions";
import ReportModal from "../../ReportModal";
import { uploadProfilePicture } from "../../../actions/auth";
import SingleImageViewer from "../../../../components/SingleImageViewer";
import { kycConfirmation, kycConfirmationMark } from "../../../actions/kyc";
import { contactPrivacyOptions } from "../../../../constants";
import ReactSelect from "../../../../components/ControllerComponent/ReactSelect";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
import KycConfirmationModal from "../../KycConfirmationModal";
import AppMenuBar from "../../AppMenuBar";

const schema = yup
  .object({
    experienceCategory: yup
      .string()
      .required("Experience Category is required"),
  })
  .required();

const ActorDetails = (props) => {
  const {
    control,
    handleSubmit,
    clearErrors,
    formState: { errors },
    reset,
    setValue,
    watch,
  } = useForm({
    resolver: yupResolver(schema),
    defaultValues: {
      experienceCategory: "",
    },
  });

  const { onClose, onRefresh, navigation } = props;

  const [reportModal, setReportModal] = useState(false);
  const [uploaderOpen, setUploaderOpen] = useState(false);
  const [kycStatus, setKycStatus] = useState(false);
  const [viewerOpen, setViewerOpen] = useState(false);
  const [imageToView, setImageToView] = useState("");

  const [modalOpen, setModalOpen] = useState({ open: false, type: undefined });
  const [transformedExperienceList, setTransformedExperienceList] = useState(
    []
  );

  const alert = useMessage();
  const dispatch = useDispatch();

  const selectedArtist = useSelector(
    (state) => state.artistReducer?.selectedArtist
  );
  const selectedArtistAuditions = useSelector(
    (state) => state.artistReducer?.selectedArtistAuditions
  );
  const selectedArtistImages =
    useSelector((state) => state.artistReducer?.selectedArtistImages) ?? [];
  const selectedArtistVideos =
    useSelector((state) => state.artistReducer?.selectedArtistVideos) ?? [];
  const selectedArtistAudios =
    useSelector((state) => state.artistReducer?.selectedArtistAudios) ?? [];
  const artistExperienceCategoryList =
    useSelector(
      (state) => state.generalReducer?.artistExperienceCategoryList
    ) ?? [];

  const selectedArtistProfileId = selectedArtist?.userId;
  console.log("Selected artist print >>> ", selectedArtistProfileId);

  useEffect(() => {
    if (
      selectedArtist &&
      selectedArtist?.kycStatus !== null &&
      selectedArtist?.kycStatus
    ) {
      console.log("print kyc status ", selectedArtist?.kycStatus);

      setKycStatus(selectedArtist?.kycStatus === "PENDING");
    }
  }, [selectedArtist]);

  useEffect(() => {
    const transformList = (list) => {
      return list.map((item) => ({
        label: item,
        value: item,
      }));
    };

    setTransformedExperienceList(transformList(artistExperienceCategoryList));
  }, [artistExperienceCategoryList]);

  const contactDetail = selectedArtist
    ? [
        { label: "Email", value: selectedArtist?.email },
        { label: "Mobile No", value: selectedArtist?.mobileNo },
      ]
    : [];

  console.log(
    "Print artist experience category list >>> ",
    artistExperienceCategoryList
  );

  const socialDetails = selectedArtist
    ? [
        {
          label: "Instagram Handle",
          value: selectedArtist?.userProfile?.instagramHandle,
        },
        {
          label: "Cintaa No",
          value: selectedArtist?.userProfile?.cintaaNumber,
        },
      ]
    : [];

  const auditionData =
    selectedArtistAuditions?.map((item) => ({
      label: item?.title ?? "-",
    })) ?? [];

  const refreshData = async () => {
    await dispatch(
      getArtistById(
        { profileId: selectedArtist.userId },
        () => {},
        (error) => {}
      )
    );
  };

  const handleDelete = async () => {
    showLoadingOverlay("Deleting profile");
    dispatch(
      deleteArtistProfiles(
        { includesProfileId: selectedArtist?.userId },
        (res) => {
          onClose();
          alert.showSuccess(res?.message ?? "Successfully deleted");
        },
        (error) => {
          alert.showError(error?.message ?? "Something went wrong");
        }
      )
    );
    hideLoadingOverlay();
  };

  const onClickDelete = () => {
    alert.showConfirmation({
      message: "Are you sure you want to delete?",
      button1Title: "Cancel",
      button2Title: "Delete",
      onPressBtn1: () => {},
      onPressBtn2: handleDelete,
    });
  };

  const handleShowCase = async () => {
    showLoadingOverlay();
    dispatch(
      markArtistShowcase(
        { includesProfileId: selectedArtist?.userId },
        (res) => {
          alert.showSuccess(res?.message ?? "Successfully Marked");
        },
        (error) => {
          alert.showError(error?.message ?? "Something went wrong");
        }
      )
    );
    hideLoadingOverlay();
  };

  const onClickShowcase = () => {
    alert.showConfirmation({
      message: "Are you sure to mark as showcase?",
      button1Title: "Cancel",
      button2Title: "Done",
      onPressBtn1: () => {},
      onPressBtn2: handleShowCase,
    });
  };

  const handleVerify = async () => {
    showLoadingOverlay();
    dispatch(
      markArtistVerified(
        { profileId: selectedArtist?.userId },
        (res) => {
          alert.showSuccess(res?.message ?? "Successfully Marked");
          refreshData();
          onRefresh();
        },
        (error) => {
          alert.showError(error?.message ?? "Something went wrong");
        }
      )
    );
    hideLoadingOverlay();
  };

  const onClickVerified = () => {
    alert.showConfirmation({
      message: `Are you sure you want to make ${selectedArtist?.firstName} verified?`,
      button1Title: "Cancel",
      button2Title: "Verify",
      onPressBtn1: () => {},
      onPressBtn2: handleVerify,
    });
  };
  const onClickEdit = () => {
    setUploaderOpen(true);
  };

  const onKycClick = async (params) => {
    console.log("Selected row data print >>> ", selectedArtist);
    const transformParams = {
      ...params,
      experienceCategoryList: transformedExperienceList,
    };
    // console.log(params.row);
    setModalOpen({ open: true, data: transformParams });
  };

  const handleUpdateProfilePic = (image) => {
    const formData = new FormData();
    formData.append("file", image[0]);
    formData.append("profileId", selectedArtist?.userId);
    console.log("Print profile Id >> ", selectedArtist?.userId);
    dispatch(
      uploadProfilePicture(
        formData,
        (res) => {
          alert.showSuccess(res?.message);
          refreshData();
          onRefresh();
        },
        (error) => {
          alert.showError(error?.message ?? "Something went wrong!!");
        }
      )
    );
  };

  const handleImageClick = (imageUrl) => {
    setImageToView(imageUrl);
    setViewerOpen(true);
  };

  const onRejectHandle = async (data) => {
    dispatch(
      kycConfirmation(
        {
          kycId: selectedArtist?.kycId,
          status: "DENIED",
          profileId: selectedArtistProfileId,
        },
        (res) => {
          onSuccess("DENIED");
          alert.showSuccess(res?.message ?? "Successfully Rejected");
          onClose();
        },
        (error) => {
          alert.showError(error?.message ?? "Something went wrong");
        }
      )
    );
  };

  const onApproveHandle = async (data) => {
    console.log("print data of experience category >>> ", data);
    dispatch(
      kycConfirmation(
        {
          kycId: selectedArtist?.kycId,
          experienceCategory: data?.experienceCategory,
          status: "APPROVED",
        },
        (res) => {
          onSuccess("APPROVED");
          alert.showSuccess(res?.message ?? "Successfully Approved");
          onClose();
        },
        (error) => {
          alert.showError(error?.message ?? "Something went wrong");
        }
      )
    );
  };

  const onApproveWithoutKYCHandle = async (data) => {
    dispatch(
      kycConfirmationMark(
        {
          profileId: selectedArtist?.userId,
          experienceCategory: data?.experienceCategory,
          status: "APPROVED",
        },
        (res) => {
          onSuccess("APPROVED");
          alert.showSuccess(res?.message ?? "Successfully Approved");
          onClose();
        },
        (error) => {
          alert.showError(error?.message ?? "Something went wrong");
        }
      )
    );
  };

  const onClickApprove = (data) => {
    alert.showConfirmation({
      message: `Are you sure you want to make ${selectedArtist?.firstName} approve?`,
      button1Title: "Cancel",
      button2Title: "Approve",
      onPressBtn1: () => {},
      onPressBtn2: () => onApproveHandle(data),
    });
  };

  const onClickApproveWithoutKYC = (data) => {
    alert.showConfirmation({
      message: `Are you sure you want to make ${selectedArtist?.firstName} approve?`,
      button1Title: "Cancel",
      button2Title: "Approve",
      onPressBtn1: () => {},
      onPressBtn2: () => onApproveWithoutKYCHandle(data),
    });
  };

  const onClickReject = (data) => {
    alert.showConfirmation({
      message: `Are you sure you want to make ${selectedArtist?.firstName} reject?`,
      button1Title: "Cancel",
      button2Title: "Reject",
      onPressBtn1: () => {},
      onPressBtn2: () => onRejectHandle(data),
    });
  };

  const onSuccess = (isSuccessStatus) => {
    if (isSuccessStatus === "DENIED" || isSuccessStatus === "APPROVED") {
      refreshData();
      onRefresh();
    }
  };

  const optionData = [
    { title: "Showcase", onPress: onClickShowcase },
    {
      title: selectedArtist?.verified ? "Verified" : "Verify",
      onPress: onClickVerified,
      color: "#004EE4",
    },
    {
      title: "Report",
      onPress: setReportModal?.bind(null, true),
      color: "#E42900",
    },
  ];

  if (!selectedArtist) return null;

  return (
    <>
      <Box className="h-full w-full flex flex-col justify-between pb-7 overflow-y-auto">
        <div>
          <div className="flex justify-evenly py-7">
            <button
              onClick={onClickDelete}
              className="py-[10px] min-w-[140px] font-['Poppins-Semibold'] text-[14px] active:bg-[#C9CCCF] border-2 border-[#C9CCCF] rounded-[4px]"
            >
              Delete
            </button>
            <button
              onClick={navigation?.goNext}
              className="py-[10px] min-w-[140px] font-['Poppins-Semibold'] text-[14px] active:bg-[#C9CCCF] border-2 border-[#C9CCCF] rounded-[4px]"
            >
              Edit
            </button>
            <div className="flex border-2 border-[#C9CCCF] rounded-[4px]">
              <AppMenuBar options={optionData}>
                <MoreHoriz className="text-[22px] text-neutral-800" />
              </AppMenuBar>
            </div>
          </div>
          <Divider />
          <div className="flex justify-center my-3">
            <div
              className={`flex justify-center items-center h-full ${
                kycStatus ? "space-x-6" : ""
              }`}
            >
              {/* <OAuth
              altSrc={require("../../../../assets/images/user-img.png")}
              component={
                <img
                  className="rounded-full w-28 h-28 border-[1px] border-gray-200"
                  src={selectedArtist?.userProfile?.profilePic?.url}
                />
              }
            /> */}
              <div className="relative">
                <OAuth
                  altSrc={require("../../../../assets/images/user-img.png")}
                  component={
                    <img
                      className="rounded-full w-36 h-36 border-[1px] border-gray-200"
                      src={selectedArtist?.userProfile?.profilePic?.url}
                      onClick={() =>
                        handleImageClick(
                          selectedArtist?.userProfile?.profilePic?.url
                        )
                      }
                      alt="Profile"
                    />
                  }
                />
                <IconButton
                  onClick={onClickEdit}
                  className="bg-[#2F80ED] text-white absolute bottom-1 right-1 p-2 transform translate-x-1/4 translate-y-1/4"
                >
                  <CameraAlt className="text-lg" />
                </IconButton>
              </div>
              {kycStatus && (
                <div className="relative">
                  <OAuth
                    altSrc={require("../../../../assets/images/user-img.png")}
                    component={
                      <img
                        className="rounded-full w-36 h-36 border-[1px] border-gray-200"
                        src={selectedArtist?.kycMedia?.url}
                        onClick={() =>
                          handleImageClick(selectedArtist?.kycMedia?.url)
                        }
                        alt="KYC Picture"
                      />
                    }
                  />
                  <IconButton
                    onClick={() => onKycClick(selectedArtist)}
                    className="bg-[#2F80ED] text-white absolute bottom-1 right-1 p-2 transform translate-x-1/4 translate-y-1/4"
                  >
                    <Info className="text-lg" />
                  </IconButton>
                </div>
              )}
            </div>
          </div>
          <Divider />
          {/* {kycStatus && (
            <div className="flex flex-col gap-5 items-center justify-between py-5 px-3">
              <div className="flex-1 w-full">
                <ReactSelect
                  hookFormControl={control}
                  label="Experience Category"
                  varName="experienceCategory"
                  key={"experienceCategory"}
                  withSelect={false}
                  options={transformedExperienceList}
                  errorMessage={errors?.experienceCategory?.message}
                />
              </div>

              <div className="flex gap-5">
                <button
                  onClick={onClickReject}
                  className="bg-[#D92121] py-[10px] min-w-[150px] font-['Poppins-Semibold'] text-[12px] active:bg-[#C9CCCF] text-[#FFF] rounded-[4px]"
                >
                  Reject
                </button>
                <button
                  onClick={handleSubmit(onClickApprove)}
                  className={clsx(
                    "bg-[#2F80ED] py-[10px] min-w-[150px] font-['Poppins-Semibold'] text-[12px] text-[#FFF] rounded-[4px]"
                  )}
                >
                  Approve
                </button>
              </div>
            </div>
          )} */}

          {selectedArtist?.kycStatus !== "APPROVED" && (
            <div className="flex flex-col gap-5 items-center justify-between py-5 px-3">
              <div className="flex-1 w-full">
                <ReactSelect
                  hookFormControl={control}
                  label="Experience Category"
                  varName="experienceCategory"
                  key={"experienceCategory"}
                  withSelect={false}
                  options={transformedExperienceList}
                  errorMessage={errors?.experienceCategory?.message}
                />
              </div>
              {kycStatus && (
                <div className="flex gap-5">
                  <button
                    onClick={onClickReject}
                    className="bg-[#D92121] py-[10px] min-w-[150px] font-['Poppins-Semibold'] text-[12px] active:bg-[#C9CCCF] text-[#FFF] rounded-[4px]"
                  >
                    Reject
                  </button>
                  <button
                    onClick={handleSubmit(onClickApprove)}
                    className={clsx(
                      "bg-[#2F80ED] py-[10px] min-w-[150px] font-['Poppins-Semibold'] text-[12px] text-[#FFF] rounded-[4px]"
                    )}
                  >
                    Approve
                  </button>
                </div>
              )}

              {!kycStatus && selectedArtist?.kycStatus !== "APPROVED" && (
                <div className="flex gap-5">
                  <button
                    onClick={handleSubmit(onClickApproveWithoutKYC)}
                    className={clsx(
                      "bg-[#2F80ED] py-[10px] min-w-[150px] font-['Poppins-Semibold'] text-[12px] text-[#FFF] rounded-[4px]"
                    )}
                  >
                    Approve Without KYC
                  </button>
                </div>
              )}
            </div>
          )}

          {/* <ValueContainer
            label={"KYC STATUS"}
            displayValue={
              <div className="flex gap-1 items-center">
                <ReactSelect
                  hookFormControl={control}
                  label="Experience Category*"
                  varName="experienceCategory"
                  key={"experienceCategory"}
                  withSelect={false}
                  // readOnly={!addNew}
                  options={contactPrivacyOptions}
                  errorMessage={errors?.experienceCategory?.message}
                />

                <button
                  onClick={onRejectHandle}
                  className="px-[5px] min-w-[30px] font-['Poppins-Semibold'] text-[12px] active:bg-[#C9CCCF] border-2 border-[#E42900] text-[#E42900] rounded-[4px]"
                >
                  Reject
                </button>
                <button
                  onClick={onApproveHandle}
                  className={clsx(
                    "px-[5px] min-w-[30px] font-['Poppins-Semibold'] text-[12px]  border-2 border-[#004EE4] text-[#004EE4] rounded-[4px]"
                    // {
                    //   "bg-opacity-70": selectedArtist?.verified,
                    //   "active:bg-[#C9CCCF]": !selectedArtist?.verified,
                    // }
                  )}
                >
                  Approve
                </button>
              </div>
            }
          /> */}
          <Divider />
          <ValueContainer
            label={"KYC STATUS"}
            displayValue={
              <div className="flex gap-1 items-center">
                {selectedArtist?.kycStatus !== null && selectedArtist?.kycStatus
                  ? selectedArtist?.kycStatus
                  : "KYC NOT GENERATED"}
              </div>
            }
          />
          {!kycStatus && selectedArtist?.userProfile?.experienceCategory ? (
            <>
              <Divider />
              <ValueContainer
                label={"EXPERIENCE CATEGORY"}
                displayValue={
                  <div className="flex gap-1 items-center">
                    {selectedArtist?.userProfile?.experienceCategory
                      ? selectedArtist?.userProfile?.experienceCategory
                      : "-"}
                  </div>
                }
              />
            </>
          ) : null}
          <Divider />
          <ValueContainer
            label={"PROFILE NAME"}
            displayValue={
              <div className="flex gap-1 items-center">
                {`${selectedArtist?.firstName} ${
                  selectedArtist?.lastName ?? ""
                }`}
                {selectedArtist?.verified && (
                  <Verified className="text-[#5D43FF] text-[14px]" />
                )}
              </div>
            }
          />
          <Divider />
          <ValueContainer
            label={"CONTACT PRIVACY"}
            displayValue={
              <div className="flex gap-1 items-center">
                {selectedArtist?.contactVisibility}
              </div>
            }
          />

          <Divider />
          <ValueContainer
            label={"EMAIL"}
            displayValue={
              <div className="flex gap-1 items-center">
                {selectedArtist?.email}
              </div>
            }
          />

          <Divider />
          <ValueContainer
            label={"MOBILE NO"}
            displayValue={
              <div className="flex gap-1 items-center">
                {selectedArtist?.mobileNo}
              </div>
            }
          />

          <Divider />
          <ValueContainer
            label={"GENDER"}
            displayValue={
              <div className="flex gap-1 items-center">
                {selectedArtist?.userProfile?.gender}
              </div>
            }
          />

          <Divider />
          <ValueContainer
            label={"DATE OF BIRTH"}
            displayValue={
              <div className="flex gap-1 items-center">
                {format(
                  new Date(selectedArtist?.userProfile?.dob),
                  "dd MMMM yyyy"
                )}
              </div>
            }
          />
          <Divider />
          <ValueContainer
            label={"EXPERIENCE YEAR"}
            displayValue={
              <div className="flex gap-1 items-center">
                {selectedArtist?.userProfile?.experienceYears
                  ? selectedArtist?.userProfile?.experienceYears
                  : "-"}
              </div>
            }
          />
          <Divider />
          <ValueContainer
            label={"BUSINESS EMAIL"}
            displayValue={
              <div className="flex gap-1 items-center">
                {selectedArtist?.userProfile?.businessEmail}
              </div>
            }
          />
          <Divider />
          <ValueContainer
            label={"BUSINESS MOBILE NO"}
            displayValue={
              <div className="flex gap-1 items-center">
                {selectedArtist?.userProfile?.businessMobileNo}
              </div>
            }
          />

          <Divider />
          <DropdownContainer
            type={Datatype.LIST}
            label="SOCIAL LINKED"
            data={socialDetails}
          />
          {/* <Divider />
          <DropdownContainer
            type={Datatype.LIST}
            label="CONTACT INFO"
            data={contactDetail}
          /> */}
          {/* <Divider /> */}
          {/* <DropdownContainer label="ACTIVITY" data={[]} /> */}
          <Divider />
          <DropdownContainer
            type={Datatype.LIST}
            label="AUDITIONS"
            data={auditionData}
          />
          <Divider />
          <ValueContainer
            label={"JOINING DATE"}
            displayValue={
              selectedArtist?.joiningDate
                ? format(new Date(selectedArtist.joiningDate), "dd MMMM yyyy")
                : ""
            }
          />
          <Divider />
          <DropdownContainer
            type={Datatype.IMAGES}
            label="IMAGES"
            data={selectedArtistImages}
          />
          <Divider />
          <DropdownContainer
            type={Datatype.VIDEOS}
            label="VIDEOS"
            data={[...selectedArtistVideos]}
          />
          <Divider />
          <DropdownContainer
            type={Datatype.AUDIOS}
            label="AUDIOS"
            data={[...selectedArtistAudios]}
          />
          <Divider />
          <DropdownContainer
            type={Datatype.STRING}
            label="BIO"
            data={selectedArtist?.userProfile?.bio}
          />
          <Divider />
          <ValueContainer
            label={"NATIONALITY"}
            displayValue={
              <div className="flex gap-1 items-center">
                {selectedArtist?.userProfile?.nationality}
              </div>
            }
          />
          <Divider />
          {/* <div className="flex flex-col justify-between items-center gap-2 py-8"> */}
          {/* <button className="w-[150px] py-[2px] bg-zinc-800 rounded-2xl text-white text-xs font-['Poppins-Regular'] leading-[30px] active:bg-gray-400">
                        SEND NOTIFICATION
                    </button> */}
          {/* <button
              onClick={onClickShowcase}
              className="w-[150px] py-[2px] bg-zinc-800 rounded-2xl text-white text-xs font-['Poppins-Regular'] leading-[30px] active:bg-gray-400"
            >
              MARK SHOWCASE
            </button> */}
          {/* <button className="w-[150px] py-[2px] bg-zinc-800 rounded-2xl text-white text-xs font-['Poppins-Regular'] leading-[30px] active:bg-gray-400">
                        SEND MESSAGE
                    </button>
                    <button className="w-[150px] py-[2px] bg-zinc-800 rounded-2xl text-white text-xs font-['Poppins-Regular'] leading-[30px] active:bg-gray-400">
                        SHOWCASE
                    </button> */}
          {/* </div> */}
          {/* <Divider /> */}
        </div>
        {/* <div className="mt-auto">
          <div className="flex justify-evenly mt-24">
            <button
              onClick={setReportModal?.bind(null, true)}
              className="py-[10px] min-w-[140px] font-['Poppins-Semibold'] text-[14px] active:bg-[#C9CCCF] border-2 border-[#E42900] text-[#E42900] rounded-[4px]"
            >
              Report
            </button>
            <button
              disabled={selectedArtist?.verified}
              onClick={onClickVerified}
              className={clsx(
                "py-[10px] min-w-[140px] font-['Poppins-Semibold'] text-[14px]  border-2 border-[#004EE4] text-[#004EE4] rounded-[4px]",
                {
                  "bg-opacity-70": selectedArtist?.verified,
                  "active:bg-[#C9CCCF]": !selectedArtist?.verified,
                }
              )}
            >
              {selectedArtist?.verified ? "Verified" : "Verify"}
            </button>
          </div>
        </div> */}
        <ReportModal
          open={reportModal}
          onClose={() => setReportModal(false)}
          id={selectedArtist?.userId}
          type="user"
        />
      </Box>
      <ImageUploadOptions
        open={uploaderOpen}
        hideCamera={true}
        onClose={setUploaderOpen?.bind(null, false)}
        onSubmit={handleUpdateProfilePic}
      />
      <SingleImageViewer
        image={imageToView}
        visible={viewerOpen}
        onClose={() => setViewerOpen(false)}
        options={(index) => (
          <IconButton
            onClick={() => setViewerOpen(false)}
            className="bg-[#0000004d] text-white"
          >
            <CameraAlt className="text-lg" />
          </IconButton>
        )}
      />
      {modalOpen.open && (
        <KycConfirmationModal
          open={modalOpen.open}
          onClose={setModalOpen.bind(this, { open: false, data: null })}
          item={modalOpen.data}
          onSuccess={onSuccess.bind(this)}
        />
      )}
    </>
  );
};

export default ActorDetails;
